// different file format column names -> standard column names
export default
{
    // bofa
    "Posted Date": "date",
    "Reference Number": "ref_num",
    "Payee": "description",
    "Address": "address",
    "Amount": "amount",
    // chase
    "Transaction Date": "tx_date",
    "Post Date": "date",
    "Description": "description",
    "Category": "bank_category",
    "Type": "bank_tx_type",

    // BOFA checking
    "Description": "description",
    "Running Bal.": "balance",
    "Date": "date",

    // chase checking
    "Posting Date": "date",
}

